import React, { Component } from 'react'
import { Grid, Col, Row } from 'react-flexbox-grid'
import RBButton from '../../controls/RBButton'
import { localize } from '../../util/Localizer'
import InputField from '../../controls/InputField'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { fetchProvinces } from '../../redux/actions/submitExpenseActions'
import RBSelectField from '../../controls/RBSelectField'
import { withStyles } from '@material-ui/core/styles'

const registrationNumberRegex = /^[a-zA-Z0-9-]{1,20}$/

const validateRegistrationNumber = registrationNumber => {
  return registrationNumber !== undefined && registrationNumberRegex.test(registrationNumber)
}

class AddPractitionerForm extends Component {
  constructor (props) {
    super(props)
    this.onAddClicked = this.onAddClicked.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.addClinic = this.addClinic.bind(this)
    this.isLoading = this.isLoading.bind(this)
    this.postalCode = React.createRef()
    this.phone = React.createRef()
    this.state = {
      newPractitioner: {},
      country: 'Canada', // left out because the api does not need it, but might need country one day if nexgen grows internationally
      newPractitionerError: {
        registrationNumber: localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.regNumberError')
      },
      isMakingApiCall: false,
      submitted: false
    }
  }

  componentDidMount () {
    if (this.props.provinces.length === 0) {
      this.props.fetchProvinces()
    }
    if (this.props.newPractitioner) {
      const np = this.props.newPractitioner.province
        ? this.props.newPractitioner
        : Object.assign({}, this.props.newPractitioner, { province: 'ON' })

      this.setState({ newPractitioner: np })
    }
  }

  onAddClicked () {
    if (this.validate()) {
      this.addClinic(this.state.newPractitioner, '')
    }
  }

  addClinic (clinic, clinicId) {
    let c = { ...clinic, clinicId }
    this.props.addClinic(c, 'prac')
  }

  validate () {
    let isValid = true
    const state = this.state.newPractitioner
    const newPractitionerError = this.state.newPractitionerError
    const p = (state.phone && state.phone.replace(/\D/g, '')) || 0
    const pc = (state.postalCode && state.postalCode.replace(/_/g, '')) || 0

    if (!state.firstName) {
      newPractitionerError.firstName = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.firstNameError')
      isValid = false
    } else {
      newPractitionerError.firstName = ''
    }

    if (!state.lastName) {
      newPractitionerError.lastName = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.lastNameError')
      isValid = false
    } else {
      newPractitionerError.lastName = ''
    }

    if (!validateRegistrationNumber(state.registrationNumber)) {
      newPractitionerError.registrationNumber = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.regNumberError')
      isValid = false
    } else {
      newPractitionerError.registrationNumber = ''
    }

    if (!state.clinicName) {
      newPractitionerError.clinic = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noClinicError')
      isValid = false
    } else {
      newPractitionerError.clinic = ''
    }

    if (!state.phone) {
      newPractitionerError.phone = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noPhoneError')
      isValid = false
    } else {
      newPractitionerError.phone = ''
    }
    if (p.length !== 10) {
      newPractitionerError.phone = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noPhoneError')
      isValid = false
    } else {
      newPractitionerError.phone = null
    }

    if (!state.addressLine1) {
      newPractitionerError.address = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noAddressError')
      isValid = false
    } else {
      newPractitionerError.address = ''
    }

    if (!state.city) {
      newPractitionerError.city = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noCityError')
      isValid = false
    } else {
      newPractitionerError.city = ''
    }

    if (pc.length !== 7) {
      newPractitionerError.postalCode = localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.noPostalCodeError')
      isValid = false
    } else {
      newPractitionerError.postalCode = ''
    }

    this.setState({
      newPractitionerError,
      submitted: true
    })

    return isValid
  }

  onCancel () {
    this.props.onCancel()
  }

  updateState (e, v) {
    if (e.target) {
      let stateItem = e.target.id
      let state = Object.assign({}, this.state.newPractitioner, { [stateItem]: v })
      this.setState({ newPractitioner: state })
    } else {
      let newPrac = Object.assign({}, this.state.newPractitioner, e)
      this.setState({ newPractitioner: newPrac })
    }
  }

  isLoading () {
    return this.state.isMakingApiCall // this.props.clinicLoading || this.props.eclinicLoading
  }

  getFormTitle () {
    const { edit = false, practitionerTitle = '' } = this.props

    const action = (edit)
      ? localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.editTitle')
      : localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.title')

    return `${action} ${practitionerTitle}`
  }

  getAddButtonTitle () {
    const { edit = false, practitionerTitle = '' } = this.props

    const action = (edit)
      ? localize('common.edit')
      : localize('common.add')

    return `${action} ${practitionerTitle}`
  }

  render () {
    const newPractitionerError = this.state.newPractitionerError
    const state = this.state.newPractitioner
    const p = (state.phone && state.phone.replace(/\D/g, '')) || 0
    const pc = (state.postalCode && state.postalCode.replace(/_/g, '')) || 0

    return (
      <Grid fluid className={this.props.classes.container}>
        <Row start='xs'>
          <Col xs={12}>
            <h3 className='marginBottom0px'>{this.getFormTitle()}</h3>
            <p className='titledLabelTitle'>{localize('error.account.activateAccount.20001018')}</p>
          </Col>
        </Row>
        <br />

        <Row start='xs'>
          <Col xs={6}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.firstName')}
              fullWidth
              id='firstName'
              errorText={!state.firstName && newPractitionerError.firstName ? newPractitionerError.firstName : null}
              value={this.state.newPractitioner.firstName || ''}
              onChange={(e, v) => this.updateState(e, v)}
              limit={30}
            />
          </Col>
          <Col xs={6}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.lastName')}
              fullWidth
              id='lastName'
              errorText={!state.lastName && newPractitionerError.lastName ? newPractitionerError.lastName : null}
              value={this.state.newPractitioner.lastName || ''}
              onChange={(e, v) => this.updateState(e, v)}
              limit={30}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <br/>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.practitionerType')}
              fullWidth
              value={this.props.practitionerTitle}
              onChange={() => null}
            />
          </Col>
        </Row>

        <Row start='xs'>
          <Col xs={12}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.registrationNumber')}
              fullWidth
              id='registrationNumber'
              errorText={ (this.state.submitted && !validateRegistrationNumber(state.registrationNumber)) ? newPractitionerError.registrationNumber : null}
              value={this.state.newPractitioner.registrationNumber || ''}
              onChange={(e, v) => this.updateState(e, v)}
              limit={20}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newPractitioner.clinicName')}
              fullWidth
              id='clinicName'
              errorText={ !state.clinicName && newPractitionerError.clinic ? newPractitionerError.clinic : null}
              value={this.state.newPractitioner.clinicName || ''}
              onChange={(e, v) => this.updateState(e, v)}
              limit={50}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <InputField
              type='tel'
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.Phonenumber')}
              mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              fullWidth
              id='phone'
              errorText={p.length !== 10 && newPractitionerError.phone ? newPractitionerError.phone : null}
              value={this.state.newPractitioner.phone || ''}
              onChange={(e, v) => this.updateState(e, v)}
            />
          </Col>
          <Col xs={12}>
            <InputField
              floatingLabelText='Address'
              fullWidth
              id='addressLine1'
              errorText={ !state.addressLine1 && newPractitionerError.address ? newPractitionerError.address : null}
              value={this.state.newPractitioner.addressLine1 || ''}
              onChange={(e, v) => this.updateState(e, v)}
              limit={50}
            />
          </Col>
          <Col xs={6}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.City')}
              fullWidth
              id='city'
              errorText={!state.city && newPractitionerError.city ? newPractitionerError.city : null}
              value={this.state.newPractitioner.city || ''}
              onChange={(e, v) => this.updateState(e, v)}
              limit={30}
            />
          </Col>
          <Col xs={6}>
            <RBSelectField
              data={this.props.provinces}
              id='province'
              label={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.Province')}
              sendValues={(v) => this.updateState(v)}
              selected={this.state.newPractitioner.province}
              fullWidth
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={6}>
            <InputField
              floatingLabelText={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.PostalCode')}
              fullWidth
              id='postalCode'
              mask={[/[A-Z]/i, /\d/, /[A-Z]/i, ' ', /\d/, /[A-Z]/i, /\d/]}
              errorText={pc.length !== 7 && newPractitionerError.postalCode ? newPractitionerError.postalCode : null}
              value={this.state.newPractitioner.postalCode}
              onChange={(e, v) => this.updateState(e, v)}
            />
          </Col>
          <Col xs={6}>
            <RBSelectField
              data={[{ id: 'Canada', text: 'Canada' }]} // to change if we get more countries...
              id='country'
              label={localize('pages.SubmitAClaim.ExtendedHealthCareProviders.newClinic.Country')}
              sendValues={(v) => this.setState(v)}
              selected={this.state.country}
              fullWidth
            />
          </Col>
        </Row>

        <br /><br />
        <Row start='xs'> {/* END OF THE FORM BUTTONS */}
          <Col xs={6}>
            <RBButton
              label={localize('common.cancel')}
              variant='outlined'
              onClick={this.onCancel}
              disabled={this.isLoading()}
              fullWidth
            />
          </Col>
          <Col xs={6}>
            <RBButton
              label={this.getAddButtonTitle()}
              variant='contained'
              primary
              onClick={() => this.onAddClicked()}
              loading={this.isLoading()}
              fullWidth
            />
          </Col>
        </Row>
      </Grid>
    )
  }
}

function mapStateToProps (state, ownProps) {
  const provinces = (state.SubmitExpenseReducer.provinces || []).map((prov) => {
    return { id: prov, text: prov }
  })

  return {
    pracLoading: state.SubmitPractitionerReducer.pracLoading,
    pracResponse: state.SubmitPractitionerReducer.pracResponse,
    pracError: state.SubmitPractitionerReducer.pracError,
    // edit clinic
    eclinicLoading: state.SubmitPractitionerReducer.eclinicLoading,
    eclinicResponse: state.SubmitPractitionerReducer.eclinicResponse,
    eclinicError: state.SubmitPractitionerReducer.eclinicError,
    claimObj: state.SubmitAClaimReducer.claimObj,
    provinces: provinces
  }
}

const ConnectedAddPractitionerForm = connect(mapStateToProps, { fetchProvinces })(injectIntl(AddPractitionerForm))

const styles = {
  container: {
    minWidth: 400,
    maxWidth: 550
  }
}

export default withStyles(styles)(ConnectedAddPractitionerForm)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/AddPractitionerForm.js